var _toConsumableArray = require("C:\\Users\\Samuele\\source\\frontend\\node_modules\\@babel\\runtime\\helpers\\toConsumableArray.js");

var getProtocol = function getProtocol(location) {
  if (location === 'injected') return 'injected';
  if (location.endsWith('.ipc')) return 'ipc';
  if (location.startsWith('wss://') || location.startsWith('ws://')) return 'ws';
  if (location.startsWith('https://') || location.startsWith('http://')) return 'http';
  return '';
};

module.exports = function (targets, presets) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray([].concat(targets).map(function (provider) {
    if (presets[provider]) {
      return presets[provider].map(function (location) {
        return {
          type: provider,
          location: location,
          protocol: getProtocol(location)
        };
      });
    } else {
      return {
        type: 'custom',
        location: provider,
        protocol: getProtocol(provider)
      };
    }
  }))).filter(function (provider) {
    if (provider.protocol || provider.type === 'injected') {
      return true;
    } else {
      console.log('eth-provider | Invalid provider preset/location: "' + provider.location + '"');
      return false;
    }
  });
};